import { getBooleanConfig } from '@zg-rentals/frontend-config';

import accessUtils from '../../../utils/accessUtils';

import { useMultiplexBuildingSessionId } from './useMultiplexBuildingSessionId';

export const useMultiplexListingFlow = () => {
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const data = getBooleanConfig('canAccessMultiplexListingFlow', true);

  const canAccessMultiplexListingFlow = accessUtils.canAccessMultiplexListingFlow({
    canAccessMultiplexListingFlowResponse: data,
  });

  const isInMultiplexListingFlow = canAccessMultiplexListingFlow && Boolean(multiplexBuildingSessionId);

  return {
    isLoading: false,
    isInMultiplexListingFlow,
  };
};
